export default __webpack_public_path__ + "static/image18-c8d454ee71c8113383573c912e05bac4.webp";